module.exports = __webpack_public_path__ + "assets/img/dzh-28.37ce0cf0.gif";